export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[60%] md:w-[45%] h-full opacity-[0.06]">
        <div className="w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-primary-500)_0%,_transparent_70%)]"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs md:text-sm font-semibold tracking-wide mb-5">
              🔥 今日热点 · 实时追踪
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight mb-3">
              51吃瓜网址 · 全网最全吃瓜速递平台
            </h1>

            <p className="text-sm md:text-base text-foreground-600 mb-5 leading-relaxed">
              每日更新不重样，娱乐八卦一手掌握
            </p>

            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 max-w-[560px] lg:max-w-none">
              51吃瓜网址汇聚全网最新最热的51今日吃瓜与51吃瓜最新资讯，覆盖51吃瓜网今日吃瓜、51吃瓜大赛等核心栏目。我们以分钟级速度追踪娱乐圈最新八卦、今日热点及实时爆料，让你不错过任何一个精彩瞬间。热门排行、深度解读、瓜友互动，打造你的全天候吃瓜社区。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500">1500+</div>
                <div className="text-xs text-foreground-500">每日更新资讯</div>
              </div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-500">7×24h</div>
                <div className="text-xs text-foreground-500">全天候实时追踪</div>
              </div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-primary-500">100+</div>
                <div className="text-xs text-foreground-500">全网信源覆盖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看今日热榜
              </a>
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-800 rounded-full font-semibold text-sm border border-background-300 hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-lg"></i>
                实时快讯追踪
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20illustration%20of%20social%20media%20gossip%20and%20hot%20news%20topics%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20artistic%20geometric%20shapes%20representing%20buzz%20and%20viral%20content%2C%20megaphone%20silhouette%20with%20sound%20waves%2C%20newspaper%20fragments%20floating%2C%20clean%20modern%20editorial%20design%20aesthetic%2C%20soft%20texture%20background%2C%20minimalist%20composition%20with%20dynamic%20movement%2C%20no%20text&width=1040&height=780&seq=hero-main-2026-v1&orientation=landscape"
                alt="51吃瓜网址 - 全网吃瓜速递平台主视觉"
                className="w-full h-full object-cover"
                title="51吃瓜网址 - 全网吃瓜速递平台"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/8 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}